import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import translationJP from "../locales/jp/translateJP.json";

const resources = {
  jp: { translation: translationJP },
};

i18next.use(initReactI18next).init({
  lng: "jp", // if you're using a language detector, do not define the lng option
  debug: true,
  resources,
});
